fragment OnboardingStepFragment on OnboardingStep {
    title
    type
    isComplete
}
